import { Controller, useFormContext } from 'react-hook-form';
import { PHONE_REGEX, isJustLetters } from 'shared-ui';

import { useLocale } from 'hooks/useLocale/useLocale';
import { Input } from 'ui/input/Input';
import { AppMessages } from 'i18n/messages';
import { AddUserFormBody } from '../AddUser.types';

import * as Styled from './AddUserPersonalDataForm.styles';

export const AddUserPersonalDataForm = () => {
  const { formatMessage } = useLocale();
  const {
    control,
    formState: { errors },
  } = useFormContext<AddUserFormBody>();

  return (
    <>
      <Controller
        name="imie"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            value={field.value || ''}
            onChange={(e) => {
              if (!isJustLetters(e.target.value)) return;

              field.onChange(e);
            }}
            required
            label={formatMessage({ id: AppMessages['users.addUser.field.firstName.label'] })}
            placeholder={formatMessage({ id: AppMessages['users.addUser.field.firstName.placeholder'] })}
            errorMessage={errors?.imie?.message}
          />
        )}
      />
      <Controller
        name="nazwisko"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            value={field.value || ''}
            onChange={(e) => {
              if (!isJustLetters(e.target.value)) return;

              field.onChange(e);
            }}
            required
            label={formatMessage({ id: AppMessages['users.addUser.field.lastName.label'] })}
            placeholder={formatMessage({ id: AppMessages['users.addUser.field.lastName.placeholder'] })}
            errorMessage={errors?.nazwisko?.message}
          />
        )}
      />
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            label={formatMessage({ id: AppMessages['users.addUser.field.email.label'] })}
            placeholder={formatMessage({ id: AppMessages['users.addUser.field.email.placeholder'] })}
            errorMessage={errors?.email?.message}
          />
        )}
      />
      <Controller
        name="telefon"
        control={control}
        render={({ field }) => (
          <Input
            {...field}
            onChange={(e) => {
              if (e.target.value && !PHONE_REGEX.test(e.target.value)) return;

              field.onChange(e);
            }}
            value={field.value || ''}
            placeholder={formatMessage({ id: AppMessages['users.addUser.field.phone.placeholder'] })}
            label={formatMessage({ id: AppMessages['users.addUser.field.phone.label'] })}
            errorMessage={errors?.telefon?.message}
          />
        )}
      />

      <Styled.DescriptionInputWrapper>
        <Controller
          name="opis"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              label={formatMessage({ id: AppMessages['users.addUser.field.description.label'] })}
              placeholder={formatMessage({ id: AppMessages['users.addUser.field.description.placeholder'] })}
              errorMessage={errors?.opis?.message}
            />
          )}
        />
      </Styled.DescriptionInputWrapper>
    </>
  );
};
